import { MainTitle } from 'common/text';
import BackButton from 'common/buttons/back';
import { Content } from 'common/containers';
import AddExpensesForm from 'components/forms/expenses/add';
const ExpensesAdd = () => {
	return (
		<>
			<MainTitle>
				<h1>Añadir gasto</h1>
				<BackButton />
			</MainTitle>
			<Content>
				<AddExpensesForm />
			</Content>
		</>
	);
};
export default ExpensesAdd;
